
  import { CustomerNote } from '@/@types/responses/customer_note/CustomerNote'
  import { defineComponent } from 'vue'
  export default defineComponent({
    name: 'CustomerNoteTile',
    props: {
      note: {
        type: CustomerNote,
        required: true
      }
    }
  })
  